
import { useLocation, useNavigate } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import images from '../../assets/images';
import InputField from '../../components/InputField/InputField';
import './SchoolProfile.scss';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../../redux/app/hooks';
import { useDispatch } from 'react-redux';
import { logout, setAdminId, setAdminProfile, setAdminProfileImage, setRefetchCurrentUser } from '../../redux/slices/authSlice';
import { useLazyQuery } from '@apollo/client';
import { GET_CURRENT_PTA_USER } from '../AdminPta/api/PtaQuery';
import { GET_CURRENT_USER } from '../AdminDashboard/api/AdminDashboardQuery';
import ToasterWithMessage from '../../components/toaster';
import { FETCH_POLICY_NO_CACHE, PTA_ROLE, SCHOOL_ADMIN, STUDENT_ROLE } from '../../utils/constants';

interface IFormInput {
    schoolName: string;
    email: string;
    website: string;
    description: string;
}

const SchoolProfile = () => {

    const profile = useAppSelector((state) => state.auth.adminProfile?.schoolAdmin?.nodes?.[0]);
    const [profileImageURL, setProfileImageURL] = useState<string>();
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const { backArrow, User } = images;
    const navigate = useNavigate();
    const location = useLocation();
    const methods = useForm<IFormInput>();
    const { reset } = methods;
    const dispatch = useDispatch();  
    const {error} = ToasterWithMessage()
    const { schoolProfileImage } = images;
    const role = useAppSelector((state) => state.auth.role);
    const studentClasscode: string |null = localStorage.getItem('studentClassCode')

    const [getCurrentUser, { loading }] = useLazyQuery(GET_CURRENT_USER,{
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {
          if(data && data?.getCurrentUser){
                dispatch(setAdminProfile({profile: data}));
                dispatch(setAdminId(data?.getCurrentUser?.nodes[0]?.schoolAdminsByUId?.nodes[0]?.saId))
                dispatch(setAdminProfileImage({ adminProfileImage: role === SCHOOL_ADMIN ? data?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saAvatarUrl ? baseUrl + data?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saAvatarUrl : schoolProfileImage : data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl ? baseUrl + data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl : schoolProfileImage }))
          }else {
            error("User Not Found!");
          }
        },
        onError: (err) => {
          error(err?.message);
          dispatch(logout());
        }
      });

    const [getCurrentPta] = useLazyQuery(GET_CURRENT_PTA_USER,{
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {
          if(data && data?.getCurrentUser){
            dispatch(setAdminProfile({profile: data}));
            dispatch(setAdminProfileImage({ adminProfileImage: data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl ? baseUrl + data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl : schoolProfileImage }))
          }
          else {
            error("User Not Found!");
          }
        },
        onError: (err) => {
          error(err?.message);
          dispatch(logout());
        }
      });

    const handleClickBack = () => {
        navigate(location?.state?.backNavigation, {
            state: {
                schoolProfile: true,
                category: location?.state?.category
            }
        });
    }

    useEffect(() => {
        if (profile) {
            setProfileImageURL(profile?.saAvatarUrl ? baseUrl + profile?.saAvatarUrl : User);
            reset({
                schoolName: profile?.saName,
                email: profile?.saEmailId,
                website: profile?.saWebsite,
                description: profile?.saDescription
            })
        }        
    },[profile]);

    useEffect(() => {
        if (role === PTA_ROLE) {
            getCurrentPta({});
        }
       else if(role === STUDENT_ROLE){
        getCurrentUser({
          variables : {
            classCode : studentClasscode
          }
        })
      }
    else {
      getCurrentUser({
        variables : {
            classCode : ""
          }
      });
    }
        // dispatch(setRefetchCurrentUser({ refetchCurrentUser: true }));
    }, []);

    return (
        <div className="SchoolProfileContainer">
            <div className='SchoolProfileInnerContainer'>
                <div className='headerContainer'>
                    <div className="titleContainer">
                        <div className="backArrow">
                            <img src={backArrow} className="backIcon" onClick={handleClickBack} alt='backIcon'/>
                        </div>
                        <div className="contentContainer">
                            <div className="title">School Profile</div>
                            <div className="subTitle">About School</div>
                        </div>
                    </div>
                </div>
                <div className='profileContainer'>
                    <FormProvider {...methods}>
                        <form className="SchoolProfileForm">
                            <div className='SchoolProfileParentContainer' >
                                <div className="SchoolProfileImage">
                                    <div className='SchoolImageContainer'>
                                        {profileImageURL && <img className='teacherImageProfileStyle' alt='TeacherImage' src={profileImageURL} />}
                                    </div>
                                </div>
                                <div className="schoolDetails">
                                    <div className="schoolDetailsField">
                                        <label className="nameOfSchool">Name of School</label>
                                        <InputField label="" name="schoolName" classname="subjectStyle" type="text" size="addTeacherField" isDisable/>
                                    </div>
                                    <div className="schoolDetailsField">
                                        <label className="nameOfSchool">Email</label>
                                        <InputField label="" name="email" classname="subjectStyle" type="text" size="addTeacherField" isDisable/>
                                    </div>
                                    <div className="schoolDetailsField">
                                        <label className="nameOfSchool">Website</label>
                                        <InputField label="" name="website" classname="subjectStyle" type="text" size="addTeacherField" isDisable/>
                                    </div>
                                    <div className="schoolDetailsField">
                                        <label className="nameOfSchool">Description</label>
                                        <InputField label="" name="description" classname="subjectStyle" type="textarea" size="addTeacherField" isDisable/>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </FormProvider>
                </div>
            </div>
        </div>
    );
}

export default SchoolProfile;